// extracted by mini-css-extract-plugin
export default {"wrapper":"RegionLabel_wrapper__qxA-h"};